var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 511.975 511.975",
    height: 512,
    viewBox: "0 0 511.975 511.975",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m496.493 422.949c-29.797-29.747-102.567-102.392-131.473-131.249 43.496-73.637 30.321-174.929-31.612-234.676-76.194-76.032-200.175-76.032-276.371 0-75.827 72.608-75.839 203.262.002 275.868 62.755 62.546 158.258 74.229 233.763 32.217l131.841 131.616c10.181 10.159 23.55 15.237 36.924 15.237 27.649.659 52.873-23.858 52.233-52.127.001-13.936-5.436-27.037-15.307-36.886zm-418.265-111.294c-64.159-61.437-64.17-171.959.002-233.395 64.509-64.377 169.478-64.369 233.991 0 64.159 61.435 64.169 171.962-.003 233.395-64.508 64.373-169.479 64.373-233.99 0zm255.182 21.236c5.118-5.107 9.906-10.456 14.376-16.006l31.107 31.054-31.42 31.353-31.231-31.178c5.944-4.685 11.684-9.75 17.168-15.223zm141.891 142.598c-8.677 8.656-22.791 8.657-31.464.002l-75.132-75.004 31.42-31.353s75.176 75.048 75.176 75.048c8.608 8.245 8.609 23.063 0 31.307z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.504 107.828h-60.845c-8.284 0-15 6.716-15 15v34.602h-45.865c-8.284 0-15 6.716-15 15v21.784h-45.85c-8.284 0-15 6.716-15 15v57.574c0 8.284 6.716 15 15 15l182.56.299c8.284 0 15-6.716 15-15v-144.259c0-8.284-6.716-15-15-15zm-136.715 143.96h-30.845v-27.574h30.845zm60.85 0h-30.845v-64.358h30.845zm60.865.299h-30.845v-114.259h30.845z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalytics);
export default __webpack_public_path__ + "static/media/data-analytics.c870ab08c0099d3f5b353612e0aec13e.svg";
export { ForwardRef as ReactComponent };